import { RiCalendarFill } from '@remixicon/react'
import { format } from 'date-fns'
import type { SelectSingleEventHandler } from 'react-day-picker'

import { Button } from '@/components/ui/button'
import { Calendar, type CalendarProps } from '@/components/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { DATE_FORMATS } from '@/constants/app'
import { cn } from '@/lib/utils'

interface DatePickerProps extends React.ComponentPropsWithoutRef<typeof Button> {
  date: Date | undefined
  setDate: SelectSingleEventHandler
  className?: string
  placeholder?: string
  withDisabledDays?: boolean
  calendarProps?: CalendarProps
}

export const DatePicker = ({
  date,
  setDate,
  className,
  withDisabledDays = true,
  placeholder = 'Choose date',
  calendarProps,
  ...props
}: DatePickerProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          onClick={(e) => e.stopPropagation()}
          variant='outline'
          className={cn('justify-start text-left text-sm font-normal', !date && 'text-grey-500', className)}
          {...props}
        >
          <RiCalendarFill />
          {date ? format(date, DATE_FORMATS.dots) : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className='w-auto p-0'
        onClick={(e) => e.stopPropagation()}
      >
        <Calendar
          {...calendarProps}
          mode='single'
          withDisabledDays={withDisabledDays}
          selected={date}
          onSelect={setDate}
        />
      </PopoverContent>
    </Popover>
  )
}
